module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAmUlEQVR4AeySwQ2EMBDETtd/0TSQz8gyCGGeaNcQO//fy58O8HTAClQAGugKQYF4vQJYIQRUAArE6xXACiGgAlAgXq8AVggBFYAC8fqXCmBZCqACitYBWoFBljJaAUXrAK3AIEsZrYCidYBWYJCljFZA0TpAKzDIUkYroGgdoBUYZCmjTgHlV8/QDnD2ct/bCtzn+vyl1xe4AAAA//84mcMzAAAABklEQVQDABHJAGH6DKeVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/chevron-left@2x.png
// module id = zmxr
// module chunks = 1